import { PropsWithChildren } from 'react'
import Styles from './PersistentToast.module.scss'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { RIGHT_RAIL_TABS_CONTAINER_ID } from 'components/DocRightRailV2/Tabs/constants'

export const Root = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  const { isMobile } = useResponsiveDesign()
  const isAnyModalOpen = document.querySelector('[class^="Modals_stack__"]')
  const isRightRailOpen = document.querySelector(`#${RIGHT_RAIL_TABS_CONTAINER_ID}`) && !isMobile && !isAnyModalOpen

  return (
    <div
      className={cx(
        Styles.root,
        'persistent-toast-container',
        { [Styles.isRightRailOpen]: isRightRailOpen },
        className,
      )}
    >
      {children}
    </div>
  )
}
